import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apartment-three',
  templateUrl: './apartment-three.component.html',
  styleUrls: ['./apartment-three.component.css']
})
export class ApartmentThreeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scroll(0, -window.scrollY);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/apartment-three/apartment-three.component.ts